import React, { useEffect, useState } from 'react';

import AcessarGranel from 'components/Granel/home/AcessarGranel';

import ResetPassword from 'newComponents/ResetPassword';
import {
  Container,
  Content,
  ContentAlign,
  ContentAlignLogin,
  ContentImages,
  ContentLogin,
  DegradeDesktop,
  DegradeMobile,
  Image,
  TextContainer,
  WelcomeText,
  PortalText,
  FirstPart,
  SecondPart,
  StyledDiv,
} from './styles';

const images = [
  '/static/login/1.png',
  '/static/login/2.png',
  '/static/login/3.png',
  '/static/login/4.png',
  '/static/login/5.png',
];

const Login = (): JSX.Element => {
  const [imageActive, setImageActive] = useState(1);
  const [showModalResetPass, setShowModalRestPass] = useState<boolean>(false);

  useEffect(() => {
    sessionStorage.removeItem('@UltragazEmpresarial:X-Mfa-Login');
    setInterval(() => {
      setImageActive((prev) => {
        if (prev === images?.length) {
          return 1;
        }
        return prev + 1;
      });
    }, 4000);
  }, []);

  const isMobile = window.innerWidth <= 768;

  return (
    <>
      <Container>
        <DegradeDesktop>
          <TextContainer>
            <WelcomeText style={{ color: '#0B29FB' }}>
              Boas-vindas ao
            </WelcomeText>
            <br />
            <PortalText style={{ color: '#0B29FB' }}>
              Portal Minha Ultragaz
            </PortalText>
          </TextContainer>
        </DegradeDesktop>

        <DegradeMobile />
        <Content>
          <ContentImages>
            {images?.map((img, index) => (
              <Image
                src={img}
                alt="Portal Minha Ultragaz"
                isActive={index + 1 === imageActive}
              />
            ))}
          </ContentImages>
          <ContentLogin>
            <ContentAlign>
              {isMobile && (
                <StyledDiv>
                  <FirstPart>Boas-vindas ao Portal </FirstPart>
                  <SecondPart>Minha Ultragaz</SecondPart>
                </StyledDiv>
              )}
              <ContentAlignLogin>
                <AcessarGranel setShowModalRestPass={setShowModalRestPass} />
              </ContentAlignLogin>
            </ContentAlign>
          </ContentLogin>
        </Content>
      </Container>
      <ResetPassword
        setShowModal={setShowModalRestPass}
        showModal={showModalResetPass}
      />
    </>
  );
};

export default Login;
